import IssuesStore from '../stores/issues-store';
import { createIssuesActions } from '../../common/actions/create-issues-actions';
import issuesService from '../../common/services';
import * as storeActions from '../store-actions/issue-store-actions';
import { AppPages } from '../../../common/routing/app-navigator';

const issuesActions = createIssuesActions(
  IssuesStore,
  issuesService,
  storeActions,
  AppPages.Issues,
);

export const loadIssues = issuesActions.loadIssues;
export const loadFilters = issuesActions.loadFilters;
export const setIssueDrawer = issuesActions.setIssueDrawer;
export const clearSelectedIssue = issuesActions.clearSelectedIssue;
export const setLoadingIssue = issuesActions.setLoadingIssue;
export const handleIssueRowClick = issuesActions.handleIssueRowClick;
export const sortIssues = issuesActions.sortIssues;
export const handleSearchFilterType = issuesActions.handleSearchFilterType;
export const initIssues = issuesActions.initIssues;
export const setMenuIssueId = issuesActions.setMenuIssueId;
export const loadStatistics = issuesActions.loadStatistics;
export const addingComment = issuesActions.addingComment;
export const loadingIssueComment = issuesActions.setLoadingIssueComment;
export const updateJiraTicketsLatestStatus =
  issuesActions.updateJiraTicketsLatestStatus;
export const exportIssuesToCSVfile = issuesActions.exportIssuesToCSVfile;
